<template>
  <div style="font-family: montserrat;">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-layout pb-12 xs12 sm12 md12 wrap>
      <v-flex>
        <v-layout wrap pt-10 justify-center>
          <v-flex xs12 md8 text-center>
            <span class="login_head" style="font-family: montserrat_Bold;">Password reset</span>
          </v-flex>
        </v-layout>
        <!-- <v-layout py-5></v-layout> -->
        <v-layout xs12 md12 wrap justify-center>
          <v-flex xs12 md6 text-center>
            <span style="font-size:13px">
              Enter your username or the email address that you used to register.
              We'll send you an email with your username and a link to reset your password.
            </span>
          </v-flex>
        </v-layout>
        <v-layout pt-12 wrap justify-center pt-3>
          <v-flex style="font-family: montserrat_Regular;" xs12 sm6 md3 pt-5>
            <v-text-field
              ref="userName"
              :rules="[rules.required]"
              v-model="userName"
              :error-messages="msg_username"
              label="Enter email or username"
              color="#26af82"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex xs12 md12 pt-2 text-center>
            <!-- <span style="font-size:14px;color:red;">{{msg}}</span><br/> -->
            <v-btn
              :disabled="false"
              width="220"
              class="text-capitalize"
              dark
              small
              :ripple="false"
              color="#26af82"
              @click="submit"
            >send</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      ServerError: false,
      userName: null,
      appLoading: false,
      msg: null,
      msg_username: null,
      formHasErrors: false,
      rules: {
        required: value => !!value || "Required"
      },
      otp: null
    };
  },
  computed: {
    form() {
      return {
        userName: this.userName
      };
    }
  },
  watch: {
    userName: function() {
      axios({
        method: "GET",
        url: "/user/check/emailorusername",
        params: {
          username: this.userName
        }
      })
        .then(response => {
          if (response.data.status == false)
            this.msg_username = response.data.msg;
          else this.msg_username = null;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  },
  methods: {
    submit() {
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;

        this.$refs[f].validate(true);
      });
      this.resetPassword();
    },
    resetPassword() {
      if (!this.formHasErrors) {
        this.appLoading = true;
        var passworddata = {};
        passworddata["username"] = this.userName;
        axios({
          method: "POST",
          url: "/forgot/password/handshake",
          data: passworddata
        })
          .then(response => {
            this.appLoading = false;
            // this.msg = response.data.msg;
            if (response.data.status) {
              this.$emit("stepper", {
                winStep: 1
              });
            } else {
              this.msg_username = response.data.msg;
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
        // setTimeout(() => {
        //   this.$emit("stepper", { winStep: 1 });
        // }, 1000);
      } else {
        this.msg = "Invalid Input";
      }
    }
  }
};
</script>
<style>
.login_head {
  font-family: opensans;
  font-size: 20px;
  font-weight: 400;
}
</style>
<style lang="scss" scoped>
// .otpinpt {
//   font-size: 14px;
//   letter-spacing: 40px;
//   width: 260px;
//   padding-left: 10px;
//   // border-bottom: 2px solid #26af82 !important;
//   background-image: linear-gradient(to left, #26af82 80%, #fff 0%);
//   background-position: bottom;
//   background-size: 50px 2px;
//   background-repeat: repeat-x;
//   background-position-x: 35px;
//   &:focus {
//     outline: none;
//   }
// }
// .otphide {
//   color: transparent;
//   text-shadow: 0 0 0 #000;
// }
</style>